import React, { useRef, useState } from 'react';
import { IMAGE_EXTENSIONS, MIME_TYPES } from 'swag-client-common/utils/constants';
import { Placement } from 'swag-client-common/constants';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { isMobile } from '../../../../../../utils/ui.utils';
import classes from './single-view-design-upload.scss';
import { SingleViewDesignLogo } from './components/single-view-design-logo';
import { SingleViewDesignUploadButton } from './components/single-view-design-upload-button';
import { SingleViewAdditionalDesignUploadButton } from './components/single-view-additional-design-upload-button';
const IMAGE_ACCEPT = [...MIME_TYPES, ...IMAGE_EXTENSIONS].join(',');
export const SingleViewDesignUploadComponent = props => {
  const {
    view,
    logos,
    showOverlay,
    shouldShowDetectedColorsCount,
    isLimitedEdition,
    shouldShowCompanyArtFolder,
    showProgressBar,
    showLogos,
    showAdditionalLogoUpload,
    showUploadLogoButton,
    showRemoveLogoButton,
    tooltipText,
    onViewNameClick,
    onSelectLogoFromList,
    onLogoDelete,
    onLogoEditColors,
    onLogoUpload
  } = props;
  const [file, setFile] = useState('');
  const inputRef = useRef(null);
  const isMobileView = isMobile();
  const handleUploadClick = e => {
    if (view.isDisabled) {
      return e === null || e === void 0 ? void 0 : e.preventDefault();
    }
    if (shouldShowCompanyArtFolder && !isMobileView) {
      e === null || e === void 0 ? void 0 : e.preventDefault();
      onSelectLogoFromList();
      return;
    }
  };
  const handleUploadEnter = () => {
    var _inputRef$current;
    if (shouldShowCompanyArtFolder && !isMobileView) {
      onSelectLogoFromList();
      return;
    }
    (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.click();
  };
  const handleLogoUpload = e => {
    var _e$target, _e$target$files;
    const file = (_e$target = e.target) === null || _e$target === void 0 ? void 0 : (_e$target$files = _e$target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0];
    e.preventDefault();
    onLogoUpload(file);
    setFile('');
  };
  const inputId = `image_${view.id}`;
  const renderUploadLogoButton = () => {
    const buttonElement = /*#__PURE__*/React.createElement(SingleViewDesignUploadButton, {
      view: view,
      inputId: inputId,
      isLimitedEdition: isLimitedEdition,
      showProgressBar: showProgressBar,
      onUploadClick: handleUploadClick,
      onUploadByEnter: handleUploadEnter
    });
    if (tooltipText) {
      return /*#__PURE__*/React.createElement(Tooltip, {
        title: tooltipText,
        mode: "light",
        placement: Placement.TOP
      }, buttonElement);
    }
    return buttonElement;
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", {
    type: "file",
    accept: IMAGE_ACCEPT,
    className: classes.hidden,
    id: inputId,
    name: inputId,
    multiple: false,
    value: file,
    onChange: handleLogoUpload,
    ref: inputRef
  }), showLogos && logos.map(logo => /*#__PURE__*/React.createElement(SingleViewDesignLogo, {
    key: logo.id,
    logo: logo,
    view: view,
    isLimitedEdition: isLimitedEdition,
    isMobileView: isMobileView,
    shouldShowDetectedColorsCount: shouldShowDetectedColorsCount,
    showRemoveLogoButton: showRemoveLogoButton,
    onViewNameClick: onViewNameClick,
    onLogoEditColors: onLogoEditColors,
    onLogoDelete: onLogoDelete
  })), showUploadLogoButton && renderUploadLogoButton(), showAdditionalLogoUpload && /*#__PURE__*/React.createElement(SingleViewAdditionalDesignUploadButton, {
    view: view,
    inputId: inputId,
    isLimitedEdition: isLimitedEdition,
    onUploadClick: handleUploadClick
  }), (showProgressBar || showOverlay) && /*#__PURE__*/React.createElement("div", {
    "data-loading": "Upload",
    className: classes.overlay
  }));
};